/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title>职位列表 
      <el-button size="small" type="success" @click="addPosition" slot="right" class="ml-auto">添加职位</el-button>
    </public-title>
    <div class="load-area">
      <el-tabs v-model="activeTab" class="mb-4" @tab-click="currentPage=1;getLists()" v-show="isAdmin">
        <el-tab-pane :label="item.name" :name="item.id" :key="item.name" v-for="item in $GVAR.StoreTypeStr"/>
      </el-tabs>
      <p v-if="positionLists.total<=0">当前没有数据</p>
      <div v-else>
        <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="Itemize in positionLists.lists" :key="Itemize.id">
          <li class="w-50 list-item-col">{{Itemize.name}}</li>
          <li class="w-50 list-item-col">
            <span v-if="Itemize.user_nums<=0">{{Itemize.user_nums}}</span>
            <el-popover class="mxh" placement="right" trigger="hover" v-else @show="getPosition(Itemize.position_user_arr,Itemize.type)">
              <!-- <p v-for="v in Itemize.position_user_arr" :key="v.id">
                {{v.truename}}-{{v.mobile}}（<span :class="[v.openid?'text-success':'text-danger']">{{v.openid?'已绑定微信':'未绑定微信'}}</span>）
              </p> -->
              <!-- <el-scrollbar wrap-class="scroll" view-class="view-box" :native="false"> -->
                <div v-for="(v, index) in PopArr" :key="index" class="mb-1">
                  <div v-if="v.username">工号：{{v.username}}</div>
                  <div class="nnsp">
                    <span class="fls">姓名：{{v.truename}}</span>
                    <i class="iconfont icon-weixin1 ml-2 ntm" :class="[ v.wechat_openid==''||v.id==v.wechat_openid? 'text-muted' : 'text-success']" v-if="v.type==1"></i>
                    <i class="iconfont icon-weixin1 ml-2 ntm" :class="[ v.wechat_openid==''||v.uid==v.wechat_openid? 'text-muted' : 'text-success']" v-else></i>
                  </div>
                  <div>手机号：{{v.mobile}}</div>
                </div>
              <!-- </el-scrollbar> -->
              <span slot="reference" class="text-link">{{Itemize.user_nums}}</span>
            </el-popover>
          </li>
          <li class="w-50 list-item-col">{{Itemize.remarks?Itemize.remarks:'暂无'}}</li>
          <li class="w-50 list-item-col" :class="[Itemize.is_forbidden ?'text-danger':'text-success']">
            {{Itemize.is_forbidden ? '禁用中':'启用中'}}
          </li>
          <li class="w-50 list-item-col d-flex flex-column"> 
            <span class="text-link" @click="showAccessFun(Itemize)">查看权限</span>
          </li>
          <li  class="w-50 list-item-col-end" v-if="storeInfo.type!=99">
            <span class="Orange mr-2" v-if="Itemize.is_system==1">不可编辑</span>
            <div v-if="Itemize.is_system!=1&&Itemize.uid==userLoginMessage.uid||userInfo.type==99&&temize.is_system!=1">
              <span class="text-link mr-2" @click="editItem(Itemize)" >编辑</span>
              <span class="text-link" @click="deleteItem(Itemize)" >删除</span>
            </div>
            <span class="Orange mr-2" v-if="Itemize.is_system!=1&&Itemize.uid!=userLoginMessage.uid">他人添加 不可编辑</span>
          </li>
          <li  class="w-50 list-item-col-end" v-else>
              <span class="text-link mr-2" @click="editItem(Itemize)" >编辑</span>
              <span class="text-link" @click="deleteItem(Itemize)" >删除</span>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="positionLists.total" :current-page="Number(queryCon.page)"
                       @current-change="v => this.currentPage=v"/>
      </div>
    </div>
    <!--账号权限-->
    <el-dialog title="账号权限" :visible.sync="showAccess" center>
      <el-tree :data="powerArr" :props="defaultProps" />
      <el-button type="primary" @click="showAccess = false" slot="footer">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState } from 'vuex'

  export default {
    name: 'Lists',
    computed: {
      ...mapState(['positionLists','positionDetail','userLoginMessage']),
      ...mapGetters(['storeInfo','isGroup','userInfo','isAdmin']),
      queryCon() { return this.$route.query },
      powerArr() { return this.positionDetail.power_arr }
    },
    watch:{
      queryCon() { this.getLists(); },
      currentPage() { this.$router.push({name:this.$route.name,query:{...this.queryCon,page:this.currentPage}}) }
    },
    data() {
      return {
        titleArr:['职位名称','职位人数','职位描述','状态','查看','操作'],
        currentPage:1,
        PopArr: [],
        activeTab:'1',
        showAccess:false,           //展示账号权限
        defaultProps: {
          children: 'children',
          label: 'title'
        },
      }
    },
    mounted() {
      if (this.queryCon.tab) this.activeTab = this.queryCon.tab
      this.getLists();
    },
    methods:{
      ...mapActions(['getUserPositionLists','deletePosition','getPositionDetail']),
      getLists() {
        let data = {
          ...this.queryCon,
          page:this.currentPage
        };
        if (this.userInfo.type === 99) data.type = this.activeTab;
        this.getUserPositionLists(data);
      },
      //跳转到添加职位
      addPosition() {
        if (!this.$GFUN.powerIsInArray([333,71,176,289,388,583])) { this._alert('您没有相关权限！',null,'error'); return; }
        //为什么要换来换去？2019/12/02 17:28:00
        // let routeUrl = this.$router.resolve({
        //   name: 'addEditPosition',
        //   query: { active:this.activeTab }
        // });
        // window.open(routeUrl.href, '_blank');
        this.$router.push({name:'addEditPosition',query:{active:this.activeTab}})
      },
      //删除职位
      deleteItem(item) {
        console.log(item.id,this.activeTab)
        if (!this.$GFUN.powerIsInArray([336,73,179,292,391,586])) { this._alert('您没有相关权限！',null,'error'); return; }
        let id={
          id:item.id,
          activeTab:this.activeTab
        }
        this._confirm('确认删除么？',() => { this.deletePosition(id) });
      },
      //查看账号权限
      showAccessFun(item) {
        if (!this.$GFUN.powerIsInArray([339,298,295,393,587])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.getPositionDetail(item.id);
        this.showAccess = true;
      },
      //跳转到编辑职位
      editItem(item) {
        if (!this.$GFUN.powerIsInArray([335,72,178,290,390,585])) { this._alert('您没有相关权限！',null,'error'); return; }
        // let routeUrl = this.$router.resolve({
        //   name: 'addEditPosition',
        //   query: {
        //     position:item.id,
        //     active:this.activeTab
        //   }
        // });
        // window.open(routeUrl.href, '_blank');
        this.$router.push({name:'addEditPosition',query:{position:item.id,active:this.activeTab}})
      },
      async getPosition (position_id, position_type) {
        this.PopArr = position_id;
        // let resData = await this.$axios.post('pc/Common/getPositionUserList', {
        //   position_id, position_type
        // })
        // if (resData.code === '00000') {
        //   this.PopArr = resData.info
        // }
      }
    },
  }
</script>

<style lang="scss" scoped>
.scroll{
  min-height: 45px;
  max-height: 50vh
}
.view-box{
  border: 1px solid red
}
.ntm{
  float: left;
}
.fls{
  float: left;
}
.nnsp{
  overflow: hidden;
}
</style>